import { createElement, Fragment, useRef, useState } from "react";
import { SKTProgressBar } from "../components/SKTProgressBar";
import { useAuth } from "../hooks/Auth";
import { useData } from "../hooks/Data";
import { OrderStatus } from "./OrderStatus";

const CreatingOrder = () => {
  return <SKTProgressBar label="Luodaan tilausta" />;
};

export const OrderFlow = ({
  phase1,
  phase2,
  createOrder,
  defaults,
  validators,
  options,
}) => {
  const myRef = useRef(null);

  const executeScroll = () => myRef.current.scrollIntoView();

  const auth = useAuth().auth;
  const [phase, setPhase] = useState(1);
  const [secret, setSecret] = useState();
  const [error, setError] = useState();

  const data = useData({
    defaults,
    validators,
  });
  const moveToSecondPhase = () => {
    if (data.values.iSZIP === data.values.iDZIP) {
      if (
        // eslint-disable-next-line no-restricted-globals
        !confirm(
          "Noutopaikan ja määräpaikan postinumerot ovat samat, oletko varma?"
        )
      )
        return;
    }
    executeScroll();
    setPhase(2);
  };

  const moveToOrderPhase = () => {
    if (data.values.iSZIP === data.values.iDZIP) {
      if (
        // eslint-disable-next-line no-restricted-globals
        !confirm(
          "Noutopaikan ja määräpaikan postinumerot ovat samat, oletko varma?"
        )
      )
        return;
    }
    createOrder(data, auth)
      .then((secret) => {
        setSecret(secret);
        executeScroll();
        setPhase(4);
      })
      .catch((error) => {
        setError(error);
        executeScroll();
        setPhase(5);
      });
    executeScroll();
    setPhase(3);
  };

  const contents = (() => {
    if (phase === 1)
      return createElement(phase1, { auth, data, options, moveToSecondPhase });
    if (phase === 2)
      return createElement(phase2, { auth, data, options, moveToOrderPhase });
    if (phase === 3) return <CreatingOrder />;
    if (phase === 4)
      return (
        <OrderStatus secret={secret} moveToSecondPhase={moveToSecondPhase} />
      );
    if (phase === 5) return <div>ERROR! {`${error}`}</div>;
  })();

  return (
    <Fragment>
      <span ref={myRef}></span>
      {contents}
    </Fragment>
  );
};
